import { Route } from '@angular/router';
import { PropertyDashboardComponent } from './dashboard.component';
import { ProjectDataResolver, ProjectsFieldDefsResolver } from 'app/modules/projects/projects.resolvers';
import { ContactsResolver } from './dashboard.resolvers';
import { PropertyTenantsPropertyUnitsResolver } from '../tenants/tenants.resolvers';
import { RelatedToType } from 'app/shared/enums';

export const dashboardRoutes: Route[] = [
  {
    path: '',
    component: PropertyDashboardComponent,
    resolve: {
      options: ProjectDataResolver,
      unit: PropertyTenantsPropertyUnitsResolver,
      contacts: ContactsResolver,
      fieldDefs: ProjectsFieldDefsResolver,
    },
    data: {
      relatedToType: RelatedToType.Property,
    },
  },
];
